<template>
  <div class="c-wrap" v-gxxt-loading="loading" @touchend="changeClick">
    <open-app-bar :open-app-info="{}" :showHome="false"></open-app-bar>
    <div class="c-icons">
      <template v-for="(c, index) in cats" :key="c.id">
        <a href="javascript:;" @click="changeCat(index)" v-if="c.index!=null">
          <img
            :src="'https://bjx-private-cdn.oss-cn-zhangjiakou.aliyuncs.com/fe/images/h5-images/h'+c.index+'.png'"
            alt
          />
        </a>
      </template>
    </div>
    <div class="fixed-cats" v-if="showFixed">
      <div class="c-cats-wrap" ref="cats2">
        <template v-for="(c,index) in cats" :key="c.id">
          <div
            class="item"
            :class="curIndex == index ? 'active' : ''"
            :id="'cats2-'+index"
            v-if="c.index!=null"
            @click="changeCat(index)"
          >
            {{c.name}}
            <span></span>
          </div>
        </template>
      </div>
    </div>
    <div class="c-part-wrap" v-for="(l, index) in list" :key="l.id">
      <div class="c-part-title" :id="'part'+index">
        0{{index + 1}}. {{cats[index] ? cats[index].name : ''}}
        <div class="c-decoration">
          <div class="line line1">
            <div class="circle"></div>
          </div>
          <div class="line line2">
            <div class="circle"></div>
          </div>
        </div>
      </div>
      <div class="c-part-desc">{{listOther[l.index]}}</div>
      <div class="c-video" v-if="l.materialUrl">
        <div :id="'J_prismPlayer'+index"></div>
      </div>
      <div class="c-list" v-if="l.goodsVOS && l.goodsVOS.length > 0">
        <div class="c-item" v-for="it in l.goodsVOS" :key="it.id" @click="jumpToCourse(it)">
          <div class="c-thumb c-default-img">
            <img :src="it.imageV" alt />
            <div class="c-tag">{{constants.goodsNames[it.type]}}</div>
          </div>
          <div class="c-info">
            <div class="c-title thidden">{{it.name}}</div>
            <div class="c-desc thidden">{{it.shareDescription}}</div>
            <div
              class="c-time"
              v-if="it.type == constants.goodsType.offlineClass"
            >{{formatCourseDate(it.offLineCourseStartTime, it.offLineCourseEndTime)}}</div>
            <div
              class="c-time thidden"
              v-if="it.type == constants.goodsType.training"
            >{{it.teacherName}}·{{it.teacherTitle}}</div>
            <div
              class="c-address thidden"
              v-if="it.type == constants.goodsType.offlineClass"
            >{{it.offLineCourseCity}} | {{it.offLineCourseVenuesName}}</div>
            <div class="c-address thidden" v-else>&nbsp;</div>
            <div class="c-price">
              <div class="price color-f50">¥{{it.newPrice}}</div>
              <!-- a、报名已截止（开课后显示）
                b、已结束（结课后显示）
                c、已售罄（开课前，票券卖完显示）
              d、仅剩5席（开课前，剩余票数小于等于5时显示）-->
              <template v-if="it.type == constants.goodsType.offlineClass">
                <div
                  class="c-other color-bbb"
                  v-if="it.toBeRegistered != 0"
                >{{constants.offlineClassStatus[it.offLineStatus]}}</div>
                <div
                  class="c-other color-bbb"
                  v-if="it.toBeRegistered == 0 && it.offLineCourseSurplusNum <= 5"
                >仅剩5席</div>
              </template>
              <template v-if="it.type == constants.goodsType.training">
                <div class="c-other color-bbb">{{it.trainCampStatExp}}</div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a
      v-if="showBeiAn"
      href="https://beian.miit.gov.cn/#/Integrated/index"
      class="beian tc"
    >京ICP备2020049181号-2</a>
    <footer-nav :active="0"></footer-nav>
    <popup :adPage="10"></popup>
  </div>
</template>

<script>
import dates from '@/utils/dates'
import footerNav from '../public/footer-nav.vue'
import { getAppScrollTop } from '@/utils/common'
import { nextTick } from '@vue/runtime-core'
import { wxShare } from '@/utils/wx-config'
import popup from '@/pages/public/popup.vue'
export default {
  components: {
    footerNav,
    popup,
  },
  data() {
    return {
      cats: [{ name: '' }],
      curIndex: 1,
      showFixed: false,
      player: [],
      list: [
        {
          goodsVOS: [],
        },
      ],
      offsetTops: [],
      lastIndex: 0,
      windowH: 1000 * this.ratio,
      listOther: {
        0: '人才万千，不知如何获取？',
        1: '人才各异，不懂人尽其才？',
        2: '科学育才≠揠苗助长',
        3: '有效避免人才流失',
      },
      loading: false,
      t1: 0,
      t2: 0,
      timer: null,
      showBeiAn: false,
    }
  },
  unmounted() {
    this.removeScroll()
    this.disposePlayer()
  },
  mounted() {
    this.bindScroll()
    this.getCats()
    this.getList()
    if (location.hostname.indexOf('gengxinxuetang') > -1) {
      this.showBeiAn = true
    }
    this.shareOut()
  },
  methods: {
    jumpToCourse(item) {
      this.$router.push({
        name: 'course-home',
        query: {
          goodsId: item.id,
          adminId: this.$route.query.adminId ? this.$route.query.adminId : '',
          origin: this.$route.query.origin,
          goodsType: item.type,
        },
      })
    },
    formatCourseDate(start, end) {
      return dates.formatCourseTimeCn(start, end)
    },
    async getCats() {
      let res = await this.api.home.getH5Cats()
      if (res && res.code == 200) {
        this.cats = []
        res.data.forEach((it) => {
          if (it.index != null) {
            this.cats.push(it)
          }
        })
      }
    },
    async getList() {
      this.loading = true
      let res = await this.api.home.getH5HomeList()
      if (res && res.code == 200) {
        this.list = res.data
      }
      this.loading = false
      nextTick(() => {
        this.list.forEach((it, index) => {
          if (it.materialUrl) {
            this.initPlay(it.materialUrl, it.index)
          }
          let obj = document.getElementById('part' + index)
          this.offsetTops.push(obj)
        })
        this.windowH =
          window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight
      })
    },
    shareOut() {
      let link =
        window.location.protocol +
        '//' +
        window.location.host +
        '#/home?origin=h5'
      let shareInfo = {
        title: 'CEO的新商业学堂',
        desc: '打造人才资本，练就管理真功夫',
        link: link,
        imgUrl: this.constants.logo,
      }
      let callback = () => {}
      wxShare({ shareInfo, callback })
    },
    changeCat(index) {
      this.scrollToPart(index)
      this.curIndex = index
      this.clickAfter = true
    },
    scrollToPart(num) {
      let top =
        document.getElementById('part' + num).offsetTop - 100 * this.ratio
      let app = document.getElementById('app')
      app.scrollTo(0, top)
    },
    GetRect(element) {
      var rect = element.getBoundingClientRect() // 距离视窗的距离
      var top = document.documentElement.clientTop
        ? document.documentElement.clientTop
        : 0 // html元素对象的上边框的宽度
      var left = document.documentElement.clientLeft
        ? document.documentElement.clientLeft
        : 0
      return {
        top: rect.top - top,
        bottom: rect.bottom - top,
        left: rect.left - left,
        right: rect.right - left,
      }
    },
    bindScroll() {
      document.getElementById('app').addEventListener('scroll', this.scrollFun)
    },
    removeScroll() {
      this.isLoadingMore = false
      document
        .getElementById('app')
        .removeEventListener('scroll', this.scrollFun)
    },
    changeClick() {
      this.clickAfter = false
    },
    scrollFun() {
      let timeAction
      if (this.isLoadingMore) {
        return
      }
      const callback = () => {
        var scrollTop = getAppScrollTop()
        if (scrollTop >= 665 * this.ratio) {
          this.showFixed = true
        } else {
          this.showFixed = false
        }
        // 滚动的时候实时改变curIndex
        this.offsetTops.forEach((dom, index) => {
          let divH = dom.offsetHeight
          let windowH = this.windowH
          let obj = this.GetRect(dom)

          if (
            obj.top > 86 * this.ratio &&
            obj.top < 450 * this.ratio &&
            obj.bottom > 0
          ) {
            // 正在视口中
            // console.log(index + 1 + '***********正在视口中')
            this.lastIndex = index
            // this.changeCat(index)
          } else {
            // this.
          }
        })
        if (!this.clickAfter) {
          this.curIndex = this.lastIndex
        }

        // var obj = GetRect($box)
        // if (obj.top >= windowH) {
        //   // 在视口之下
        //   console.log('84在视口之下')
        // }
        // if (obj.top < windowH && obj.bottom >= windowH) {
        //   // 正在出现
        //   console.log('84正在出现')
        // }
        // if (
        //   obj.top > 0 &&
        //   obj.top < windowH &&
        //   obj.bottom > 0 &&
        //   obj.bottom < windowH
        // ) {
        //   // 正在视口中
        //   console.log('84正在视口中')
        // }
        // if (obj.top <= 0 && obj.bottom <= divH && obj.bottom > 0) {
        //   // 正在离开视口
        //   console.log('84正在离开视口')
        // }
        // if (obj.bottom <= 0) {
        //   // 已经离开视口
        //   console.log('84在视口之上')
        // }
      }
      if (timeAction) {
        clearTimeout(timeAction)
      }
      timeAction = setTimeout(callback, 50)
    },
    disposePlayer() {
      this.player.forEach((it) => it.dispose())
    },
    initPlay(sourceUrl, index) {
      this.player[index] = new Aliplayer(
        {
          id: 'J_prismPlayer' + index,
          source: sourceUrl,
          width: '100%',
          height: '100%',
          // height: 385 * this.ratio + 'px',
          autoplay: false,
          isLive: false,
          rePlay: false,
          playsinline: true,
          preload: true,
          controlBarVisibility: 'click',
          useH5Prism: true,
          cover:
            'https://bjx-private-cdn.oss-cn-zhangjiakou.aliyuncs.com/fe/images/h5-images/home-video-mask' +
            index +
            '.jpg?v=1.0',
        },
        function (player) {
          // console.log('The player is created')
        }
      )
      this.player[index].on('completeSeek', () => {
        let nails = document.getElementsByClassName('prism-thumbnail')
        for (let i = 0; i < nails.length; i++) {
          nails[i].style.display = 'none'
        }
      })
      this.player[index].on('play', () => {
        this.player.forEach((item, i) => {
          if (index != i) {
            this.player[i].pause()
          }
        })
      })
    },
  },
}
</script>

<style lang="less" scoped>
.fixed-cats {
  width: 750px;
  position: fixed;
  top: 0;
  z-index: 6;
  background: #fff;
}
::-webkit-scrollbar {
  display: none;
}
.c-cats-wrap {
  display: flex;
  overflow: auto;
  padding: 10px 0 10px 32px;
  scroll-behavior: smooth;
  .item {
    font-size: 30px;
    font-weight: 500;
    color: #888888;
    line-height: 66px;
    margin-right: 50px;
    position: relative;
    white-space: nowrap;
  }
  .active {
    color: #333;
    span {
      width: calc(100% - 10px);
    }
  }
  span {
    display: block;
    width: 0;
    position: absolute;
    height: 6px;
    border-radius: 3px;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    background-color: #f50;
    transition: width 0.3s;
  }
}
.c-wrap {
  background: url('~@/assets/images/home/home-bg.png') no-repeat 0 90px,
    url('~@/assets/images/home/home-bg2.png') repeat-y 0 588px;
  background-size: 100% auto;
  background-color: #ff4400;
  padding-bottom: 220px;
  min-height: 100%;
  .c-part-desc {
    font-size: 44px;
    color: #ffffff;
    line-height: 44px;
    padding-top: 20px;
    padding-bottom: 30px;
  }
  .c-list {
    width: 686px;
    background: #fcfafb;
    border-radius: 10px;
    margin: 0 auto;
    padding: 10px 0;
    .c-item {
      padding: 20px;
      display: flex;
      .c-info {
        flex: 1;
        text-align: left;
        padding-left: 20px;
      }
      .c-title {
        width: 436px;
        height: 48px;
        font-size: 32px;
        font-weight: 500;
        color: #333333;
        line-height: 48px;
      }
      .c-desc {
        width: 436px;
        height: 64px;
        font-size: 26px;
        font-weight: 400;
        color: #666666;
        line-height: 64px;
        margin-bottom: 10px;
      }
      .c-time,
      .c-address {
        font-size: 24px;
        color: #888888;
        line-height: 36px;
        width: 446px;
      }
      .c-price {
        display: flex;
        justify-content: space-between;
        padding-top: 14px;
        line-height: 38px;
        .c-other {
          flex: 60% 0 0;
          text-align: right;
          font-size: 24px;
        }
        .price {
          font-weight: bold;
          color: #ff5500;
        }
      }
      .c-thumb {
        width: 180px;
        height: 240px;
        position: relative;
        .c-tag {
          position: absolute;
          width: 76px;
          line-height: 32px;
          background: rgba(0, 0, 0, 0.4);
          border-radius: 4px;
          bottom: 10px;
          right: 10px;
          z-index: 1;
          color: #f9f9f9;
        }
        img {
          width: 100%;
          height: 100%;
          border-radius: 8px;
        }
      }
    }
  }
  .c-part-title {
    position: relative;
    color: #fff;
    font-size: 44px;
    font-weight: 600;
    color: #ffffff;
    line-height: 60px;
    margin-top: 60px;
    .c-decoration {
      width: 100%;
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      .line {
        width: 160px;
        height: 2px;
        background: #fff;
        position: absolute;
        &.line1 {
          left: 90px;
        }
        &.line2 {
          left: 500px;
          .circle {
            top: -5px;
            left: -10px;
            right: inherit;
          }
        }
        .circle {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          position: absolute;
          top: -5px;
          right: -10px;
          border: 2px solid #fff;
        }
      }
    }
  }
}
.c-icons {
  padding-top: 540px;
  display: flex;
  justify-content: space-between;
  margin: 0 32px;
  img {
    width: 154px;
    height: 128px;
  }
}
.color-f50 {
  color: #f50;
}
.color-bbb {
  color: #bbb;
}
.c-video {
  width: 686px;
  height: 384px;
  border-radius: 10px;
  overflow: hidden;
  background: transparent;
  margin: 0 auto 30px;
  position: relative;
  z-index: 5;
}
.beian {
  font-size: 24px;
  font-weight: 500;
  color: #ffffff;
  line-height: 24px;
  padding-top: 50px;
}
</style>